// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2hYY9","label":"CategoryService_label__2RNKi","location":"CategoryService_location__yiK3F"};